import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";
import { MentionModel } from "../models/MentionModel";
import { QuestionModel } from "../models/QuestionModel";
import { ChoiceModel } from "../models/ChoiceModel";
import { QuestionnaireModel } from "../models/QuestionnaireModel";
import { translate } from "../models/utilities/translationUtilities";

export class ChoiceRecalledValue extends RecalledValue {
    choice: ChoiceModel;
    language: string;
    questionnaire: QuestionnaireModel;
    question: QuestionModel;
    mention: MentionModel;

    constructor(
        question: QuestionModel,
        language: string,
        questionnaire: QuestionnaireModel,
        choice: ChoiceModel,
        mention: MentionModel,
    ) {
        super();
        this.question = question;
        this.language = language;
        this.questionnaire = questionnaire;
        this.choice = choice;
        this.mention = mention;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "openend":
                return this.mention != null ? this.mention.openEnd : "";
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
            case "image":
                return this.toImage();
        }
        return this;
    }

    toImage(): string {
        return `<img src="${translate(this.choice, "ImageUrl", this.language)}" />`;
    }

    toCode(mentionId = 0): string {
        return this.choice.value;
    }

    toText(): string {
        if (this.choice) return translate(this.choice, "TEXT", this.language);
    }
}
